module.exports = __webpack_public_path__ + "img/swiper2.1b4b7f8c.jpg";